module.exports = __webpack_public_path__ + "assets/img/cdzq.a20442d7.png";